export * from '../src/composites/wui-profile-button-v2/index.js';
//# sourceMappingURL=wui-profile-button-v2.js.map